export const DELETE_KE_MEMBERSHIP_MODAL_NAME =
  'DELETE_KE_MEMBERSHIP_MODAL_NAME';
